/* eslint-disable jsx-a11y/no-onchange */
import React, { FC, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link, NavLink } from 'react-router-dom'

import './styles.scss'

import logo from '../../assets/img/logoBlue.png'
import { createCookie, readCookie } from '../../utils/cookies'
import { Language } from '../../types/utils'
import { Routes } from '../../routing/routes'
import { setLanguage } from '../../store/languages/actions'
import { Plann3rStore } from '../../store/types'

const Header: FC = () => {
  const [navIsOpen, setNavIsOpen] = useState(false)

  const { strings, language, availableLanguages } = useSelector(
    (state: Plann3rStore) => state.languages,
  )
  const { show, showNavlinks } = useSelector(
    (state: Plann3rStore) => state.general.header,
  )

  const dispatch = useDispatch()

  // TODO: change to use general store
  if (readCookie('token')) {
    
    return (
      <header className="plann3rHeader">
        {show && (
          <nav className="nav">
            <div className="container">
              <div className="nav-left">
                <Link className="nav-item" to={Routes.HOME}>
                  <img
                    src={logo}
                    className="logoPlanner"
                    alt="Plann3r"
                    title="Plann3r"
                  />
                </Link>
              </div>

              <span
                className="nav-toggle"
                onClick={() => setNavIsOpen(!navIsOpen)}
                role="presentation"
              >
                <span />
                <span />
                <span />
              </span>

              {showNavlinks && (
                <div
                  className={
                    'nav-right nav-menu ' + (navIsOpen ? 'is-active' : '')
                  }
                >
                  <NavLink className="nav-item" to={Routes.PAGES_MANAGEMENT}>
                    {strings.header.pages}
                  </NavLink>

                  <NavLink className="nav-item" to={Routes.MY_MEETINGS}>
                    {strings.header.meetings}
                  </NavLink>

                  <NavLink className="nav-item" to={Routes.SETTINGS}>
                    {strings.header.settings}
                  </NavLink>

                  <NavLink className="nav-item" to={Routes.LOGOUT}>
                    {strings.header.logout}
                  </NavLink>

                  <select
                    className="nav-item"
                    onChange={(e) => {
                      dispatch(setLanguage(e.target.value))
                      createCookie('language', e.target.value, 60)
                      setNavIsOpen(false)
                    }}
                    value={language}
                  >
                    {availableLanguages.map((language: Language) => {
                      return (
                        <option value={language.code} key={language.code}>
                          {language.code}
                        </option>
                      )
                    })}
                  </select>
                </div>
              )}
            </div>
          </nav>
        )}
      </header>
    )
  } else {
    return (
      <header className="plann3rHeader">
        {show && (
          <nav className="nav">
            <div className="container">
              <div className="nav-left">
                <Link className="nav-item" to={Routes.HOME}>
                  <img
                    src={logo}
                    className="logoPlanner"
                    alt="Plann3r"
                    title="Plann3r"
                  />
                </Link>
              </div>

              <span
                className="nav-toggle"
                onClick={() => setNavIsOpen(!navIsOpen)}
                role="presentation"
              >
                <span />
                <span />
                <span />
              </span>

              {showNavlinks && (
                <div
                  className={
                    'nav-right nav-menu ' + (navIsOpen ? 'is-active' : '')
                  }
                >
                  <NavLink className="nav-item-button" to={Routes.LOGIN}>
                    {strings.header.login}
                  </NavLink>
                </div>
              )}
            </div>
          </nav>
        )}
      </header>
    )
  }
}

export default Header
